<template>
  <div class="messages__chats">
    <div class="messages__chats__search">
      <ChatListSearch
        v-if="shouldShowSearch"
        :key="chatScopePath"
        :chat-scope="chatScopePath"
        :search="search"
        :search-query="searchQuery"
      />
    </div>
    <div class="messages__chats__list">
      <ChatList :chats="chats" />
      <div v-if="shouldShowLoadMore" class="messages__chats__list__load_more">
        <button class="button button--small button--primary_outline" type="button" @click="loadMore()">
          {{ i18n.$gettext('Show more') }}
        </button>
      </div>
    </div>

    <div v-if="chatCount > chats.length && shouldShowSearch" class="messages__chats__count">
      <p aria-live="polite" aria-atomic="true">
        {{
          i18n.$gettext('Showing %{count} out of %{total} active members.', { count: chats.length, total: chatCount })
        }}
      </p>
      <p v-if="shouldRenderSearchHint">
        {{
          i18n.$gettext(
            'If you’re looking for a specific member that is not on the list, please use the search bar above to find them.'
          )
        }}
      </p>
    </div>
  </div>
</template>

<script>
import ChatList from './ChatList.vue'
import ChatListSearch from './ChatListSearch.vue'
import { isPublisherChatScope } from './route_helpers.js'
import { mapGetters, mapActions } from 'vuex'
const SEARCH_DELAY = 300

export default {
  name: 'Chats',
  components: { ChatList, ChatListSearch },
  data: () => ({
    searchQuery: '',
    fetchTimeout: null
  }),
  computed: {
    ...mapGetters(['getTotalChatCount', 'getChatsList', 'getChatScopeByPath']),
    shouldShowSearch() {
      return isPublisherChatScope(this.$route)
    },
    chatCount() {
      return this.getTotalChatCount(this.$route.params.chatScope)
    },
    shouldRenderSearchHint() {
      return !this.getChatScopeByPath(this.$route.params.chatScope).searchQuery
    },
    chats() {
      return this.getChatsList(this.$route.params.chatScope)
    },
    chatScopePath() {
      return this.$route.params.chatScope
    },
    shouldShowLoadMore() {
      return isPublisherChatScope(this.$route) && this.chatCount > this.chats.length && !this.searching
    },
    searching() {
      return this.searchQuery !== ''
    }
  },
  methods: {
    ...mapActions(['fetchChatsPreviewPublicationScope', 'fetchChats']),
    pagesCount() {
      return this.getChatScopeByPath(this.$route.params.chatScope).pagesCount || 1
    },
    search(chatScope, searchQuery) {
      this.searchQuery = searchQuery
      this.reloadChatScope(chatScope, 1)
    },
    loadMore(chatScope) {
      this.reloadChatScope(this.$route.params.chatScope, this.pagesCount() + 1)
    },
    reloadChatScope(chatScope, pagesCount) {
      if (this.fetchTimeout) {
        window.clearTimeout(this.fetchTimeout)
      }
      // TODO: improve accessibility of "load more" / "live search", announcing results
      this.fetchTimeout = window.setTimeout(() => {
        this.fetchChatsPreviewPublicationScope({
          route: this.$route,
          chatScope,
          searchQuery: this.searchQuery,
          pagesCount
        })
      }, SEARCH_DELAY)
    }
  }
}
</script>
